import 'angular';

import { DealershipAdvertisingSettingsCtrl } from './dealership.advertising-settings';
import { DealershipStates }                  from './dealership.states.ajs';
import { DealershipSaleCtrl }                from './dealership.sale';
import { DealershipService }                 from './dealership.service';
import { DealershipSettingsCtrl }            from './dealership.settings';
import { DealershipTemplateCtrl }            from './dealership.template';
import { DealershipTemplatesCtrl }           from './dealership.templates';
import { DealershipTransactionCenterCtrl }   from './dealership.transaction-center';
import { DealershipTransactionsCtrl }        from './dealership.transactions';

angular.module('workshop.dealership', [])
.config(DealershipStates)
.controller('DealershipAdvertisingSettingsCtrl', DealershipAdvertisingSettingsCtrl)
.controller('DealershipSaleCtrl', DealershipSaleCtrl)
.controller('DealershipSettingsCtrl', DealershipSettingsCtrl)
.controller('DealershipTemplateCtrl', DealershipTemplateCtrl)
.controller('DealershipTemplatesCtrl', DealershipTemplatesCtrl)
.controller('DealershipTransactionCenterCtrl', DealershipTransactionCenterCtrl)
.controller('DealershipTransactionsCtrl', DealershipTransactionsCtrl)
.factory('Dealership', DealershipService);